import { Stack, StackProps } from '@mantine/core';
import { PropsWithChildren, useState, useCallback, DragEvent } from 'react';

export const FileDroppableStack = ({
  children,
  onDragOver,
  onDrop,
  disabled,
  ...props
}: PropsWithChildren & StackProps & { disabled: boolean }) => {
  const [isDraggedOver, setDraggedOver] = useState(false);

  const handleDragOver = useCallback(
    (e: DragEvent<HTMLDivElement>) => {
      if (!e.dataTransfer.types.includes('Files')) {
        return;
      }
      e.preventDefault();
      onDragOver?.(e);
      if (!isDraggedOver) {
        setDraggedOver(true);
      }
    },
    [isDraggedOver, onDragOver, setDraggedOver]
  );

  const handleDragLeave = useCallback(() => {
    setDraggedOver(false);
  }, [setDraggedOver]);

  const handleDrop = useCallback(
    (e: DragEvent<HTMLDivElement>) => {
      if (!e.dataTransfer.types.includes('Files')) {
        return;
      }
      setDraggedOver(false);
      e.preventDefault();
      e.stopPropagation();
      onDrop?.(e);
    },
    [onDrop, setDraggedOver]
  );

  return (
    <Stack
      py='xs'
      bg={isDraggedOver ? 'gray.2' : props.bg}
      style={{ borderRadius: '5px', transition: 'background-color 100ms' }}
      onDragOver={disabled ? undefined : handleDragOver}
      onDragLeave={disabled ? undefined : handleDragLeave}
      onDrop={disabled ? undefined : handleDrop}
      {...props}
    >
      {children}
    </Stack>
  );
};
